<main class="main-section">
  <div>
    <img src="assets/img/image-header.jpg" alt="" class="image-header" role="presentation">
  </div>

  <div class="greeting">
    <img src="assets/img/Icono-Error.jpg" alt="Icon" class="icon">
    <h3>{{ otpService.errorMsg }}</h3>
  </div>
</main>
